// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d850c3d0","239":"d7d6d3d8","455":"34ff0f7f"}[chunkId] + ".chunk.js";
};